module.exports = __webpack_public_path__ + "static/1310306458.74fa66ac.jpg";